import { useQuery } from '@tanstack/react-query';
import { api } from './api-client';
import type { MeResponse } from './types';

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => api.get<MeResponse>('/v1/me'),
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
}
